<template>
  <div class="my-header">
    <div class="wrap container">
      <!-- <img :src="require(`../../assets/${assetsConfig.homePage.header.logo}`)"/> -->
      <svg class="img" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 277.2 75.8" style="enable-background:new 0 0 277.2 75.8;" xml:space="preserve">
        <g>
          <path class="st0" d="M92.4,59.1h5.2l1.7-1.7h-4.8V55h7.2l1.5-1.4H92.9v-2.4h12.8l1.6-1.5h6.9l-1.6,1.5h11v2.4h-13.4l-1.5,1.4H122
            v2.4h-15.7l-1.8,1.7h19.6v2.4h-3.6l3.6,2.8h-6.9l-3.6-2.8h-11.5l-2.8,2.8h-6.9l2.8-2.8h-2.8C92.4,61.5,92.4,59.1,92.4,59.1z
            M104,69.5L98,74h-5.6l6-4.5H104z M93.7,65h5.6l4.8,3.8h-5.5L93.7,65z M102.7,72v-0.9h3.6V62h4.8v12h-0.3h-4.4h-0.8 M112.9,68.8
            l4.4-3.8h5.6l-4.4,3.8H112.9z M124.1,74h-5.6l-5.5-4.5h5.5L124.1,74z"/>
          <path class="st0" d="M142.8,74v-2.8h2.8v-13h-2.8v-2.5h2.8v-6.1h5v6.1h3v2.5h-3v12.9h3V74H142.8z M154.6,71.2h19.9V74h-19.9V71.2z
            M159.9,69.3h-4.6V50h4.6v2.2V50h13.9v19.4h-4.7 M159.9,58.2h9.2v-5.5h-9.2V58.2z M159.9,65.8h9.2v-4.9h-9.2V65.8z"/>
          <path class="st0" d="M193.2,62l3.7-4.2h-3.7v-2.1h5.6l2.5-2.8h-2.9l-0.9,1.3h-4.3l3.1-4.6h4.3l-0.8,1.2h9.3V53h-3.5l-2.5,2.8h7.1
            v2.1h-3.3l3.7,4.2h-4.3l-3.7-4.2h-1.3l-3.7,4.2L193.2,62L193.2,62z M199.7,74h-5V62.8h5l-0.1,0.3l0.1-0.3h18.9l0,0h4.8V74h-4.8
            M199.7,65.2V67h18.9v-1.8H199.7z M199.7,69.2V71h18.9v-1.9L199.7,69.2L199.7,69.2z M215.1,62H211V50.2h4.1v1.4v-1.4h9.7V62h-4.2
            M215.1,52.7v6.9h5.6v-6.9H215.1z"/>
          <g>
            <path class="st0" d="M248.6,74h-5l1.6-5.9h5L248.6,74z M244.7,50.4h6v-0.8h2.1v0.8h6v1.9h-6v1h5.3v1.2h-5.3v1h6.3v1.9h-6.3v0.9
              h-2.1v-0.9h-6.3v-1.9h6.3v-1h-5.4v-1.2h5.4v-1h-6L244.7,50.4L244.7,50.4z M245.2,65.5h22.7V64h-21v-1.8h21v-1.5h-22.7v-1.6h28.3
              v8.1h-28.3V65.5z M251.5,68.1h5l-1.1,4.1h13.3V74H250L251.5,68.1z M262.8,71.2l-0.3-1.3h-5l0.5-1.8h9l0.8,3.1
              C267.8,71.2,262.8,71.2,262.8,71.2z M270.2,74l-1.6-5.9h5l1.6,5.9H270.2z"/>
          </g>
          <polygon class="st1" points="212.7,8.6 203.1,8.6 185.7,38.9 195.2,38.9"/>
          <path class="st2" d="M104.4,16.5H90.1V8.6h38.6v7.9h-14.9v22.4h-9.5V16.5H104.4z"/>
          <path class="st2" d="M136.6,38.9V8.6h9.5v30.3H136.6z"/>
          <path class="st2" d="M168.3,16.5H154V8.6h38.7l-4.5,7.9h-10.4v22.4h-9.5V16.5z"/>
          <rect x="238.1" y="19.8" class="st1" width="9.5" height="19.1"/>
          <path class="st0" d="M159.6,26.7"/>
          <polygon class="st1" points="203.2,8.6 212.7,8.6 230.2,38.9 220.6,38.9 207.9,16.9"/>
          <polygon class="st1" points="203.1,38.9 212.7,38.9 207.9,30.6   "/>
          <path class="st2" d="M267.6,8.6v22.5L250.8,9.3c0.4,1,0.6,2.1,0.6,3.3c0,2.3-0.9,4.3-2.3,5.9L265.4,39h11.7V8.6H267.6z"/>
          <circle class="st1" cx="242.8" cy="11.9" r="4.8"/>
          <g>
            <path class="st2" d="M64.7,23.9c0.9,0,1.6,0.7,1.6,1.6v8.4l0,0v28.4c5.4-6.5,8.6-14.8,8.6-23.8c0-8.8-3-16.9-8.2-23.3
              c-2.1,2.3-5.1,3.7-8.5,3.7c-6.4,0-11.5-5.1-11.5-11.5c0-1.8,0.4-3.4,1.1-4.9C44.5,1.5,41,1,37.4,1C16.8,1,0,17.8,0,38.4
              C0,48.8,4.3,58.3,11.2,65l15-41.1"/>
            <path class="st2" d="M22.8,72.9c4.5,1.9,9.5,3,14.7,3c5.3,0,10.3-1.1,14.8-3.1V59.6H40.6v-8.7h11.6V38.4H35.3L22.8,72.9z"/>
          </g>
          <circle class="st1" cx="58.2" cy="7.3" r="7.3"/>
          <polygon class="st0" points="260,50.4 266,50.4 266,49.7 268.1,49.7 268.1,50.4 274.1,50.4 274.1,52.3 268.1,52.3 268.1,53.3
            273.4,53.3 273.4,54.5 268.1,54.5 268.1,55.5 274.4,55.5 274.4,57.5 268.1,57.5 268.1,58.3 266,58.3 266,57.5 259.7,57.5
            259.7,55.5 266,55.5 266,54.5 260.6,54.5 260.6,53.3 266,53.3 266,52.3 260,52.3"/>
        </g>
      </svg>
      <ul class="nav-list">
        <li class="list"><router-link to="/" :class="{'router-link-exact-active': homeActive}"><span>TitanOS</span></router-link></li>
        <li class="list">
          <router-link to="/resolution/power" :class="{'router-link-exact-active': resolutionActive}"><span>行业案例</span></router-link>
          <div class="sub-list-wrap fadeIn">
            <ul class="container">
              <li><router-link to="/resolution/power"><span>电力行业</span></router-link></li>
              <li><router-link to="/resolution/teach"><span>教育行业</span></router-link></li>
              <li><router-link to="/resolution/energy"><span>能源行业</span></router-link></li>
              <li><router-link to="/resolution/traffic"><span>交通行业</span></router-link></li>
              <li><router-link to="/resolution/port"><span>制造行业</span></router-link></li>
              <li><router-link to="/resolution/video"><span>音视频分析</span></router-link></li>
            </ul>
          </div>
        </li>
        <!-- <li class="list"><router-link to="/service" :class="{'router-link-exact-active': serviceActive}"><span>合作与服务</span></router-link></li> -->
        <li class="list"><router-link to="/aboutus" :class="{'router-link-exact-active': aboutUsActive}"><span>关于我们</span></router-link></li>
      </ul>
      <!-- <Button ghost class="btn" @click="showConsultationModal">立即咨询</Button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-header',
  data() {
    return {
      sublist: false,
      assetsConfig: ASSETS_CONFIG
    }
  },
  computed: {
    homeActive() {
      return this.$route.path === '/' || this.$route.path === '/home'
    },
    resolutionActive() {
      return this.$route.path.includes('/resolution')
    },
    serviceActive() {
      return this.$route.path.includes('/service')
    },
    aboutUsActive() {
      return this.$route.path.includes('/aboutus')
    }
  },
  methods: {
    showConsultationModal() {
      this.$emit('on-show', true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.st0
  fill #FFFFFF
.st1
  fill #EA1C26
.st2
  fill #0052D9
.my-header
  width 100%
  min-width 1200px
  height 68px
  line-height 68px
  font-size 14px
  position fixed
  left 0
  top 0
  z-index 100
  .wrap
    overflow hidden
    .img
      width 116px
      height 32px
      float left
      margin-top 18px
    .nav-list
      color #b7b7c3
      height 68px
      line-height 68px
      float left
      margin-left 17px
      li.list
        float left
        &>a
          display block
          padding 0 20px
          color inherit
          &>span
            position relative
            display inline-block
          &:hover, &.router-link-exact-active
            color iwhite
            &>span::after
              content ''
              display block
              height 2px
              width 100%
              background iblue
              position absolute
              bottom 20px
              left 0
        &:hover
          .sub-list-wrap
            display block
          &>a
            color iwhite
            &>span::after
              content ''
              display block
              height 2px
              width 100%
              background iblue
              position absolute
              bottom 20px
              left 0
    .sub-list-wrap
      position absolute
      background ibgc
      height 60px
      line-height 60px
      width 100%
      left 0
      top 68px
      display none
      border-top 1px solid #565773
      transition all 0.4s ease
      -o-transition all 0.4s ease
      -webkit-transition all 0.4s ease
      -moz-transition all 0.4s ease
      -ms-transition all 0.4s ease
      ul
        overflow hidden
        padding-left 126px
        li
          float left
          a
            padding 0 27px
            color iwhite
            opacity 0.7
            &>span
              position relative
              display inline-block
            &:hover,&.router-link-exact-active
              opacity 1
.btn
  float right
  margin-top 18px
</style>



// WEBPACK FOOTER //
// src/components/basic/MyHeader.vue